
export const get_user = () => {
  if ( localStorage.getItem('user') ) {
    return JSON.parse(localStorage.getItem('user'));
  } else {
    return null;
  }
}